import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne, RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useState} from "react";
import {RouteHelper} from "../../../route/RouteHelper";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import VowDetailBaseInfo from "./VowDetailBaseInfo";
import {VowService} from "../../../serverService/vow/VowService";
import VowDetailGateway from "./VowDetailGateway";
import VowTransactions from "./VowTransactions";

export default function VowDetail() {

    const navigate = useNavigate()
    const {state} = useLocation()
    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.VowDetail.name);

    const [tabSelectedValue, setTabSelectedValue] = useState(tabTypes.detail.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }


    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb
                        breadCrumbItems={[

                            raikoBreadCrumbItemGenerator(
                                RouteHelper.VowList.name,
                                RouteHelper.VowList.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                pageTitle,
                                ""
                            ),
                        ]}/>

                    <RaikoButtonSecondary
                        label={"بازگشت"}
                        onClick={_ => {
                            navigate(-1)
                        }}/>
                </RaikoFlexFirstChildGrowOne>

                <TabContext value={tabSelectedValue}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <TabList onChange={handleChangeTab}
                                 id="default-tab-container"
                                 variant="scrollable"
                        >
                            <Tab
                                label={tabTypes.detail.title}
                                value={tabTypes.detail.id}/>

                           {/* <Tab
                                label={tabTypes.gateway.title}
                                value={tabTypes.gateway.id}/>*/}
                            <Tab
                                label={tabTypes.transactions.title}
                                value={tabTypes.transactions.id}/>

                        </TabList>
                    </Box>
                    <TabPanel value={tabTypes.detail.id}>
                        <VowDetailBaseInfo/>
                    </TabPanel>
                    {/*<TabPanel value={tabTypes.gateway.id}>
                    </TabPanel>*/}
                    <TabPanel value={tabTypes.transactions.id}>
                        <VowTransactions/>
                    </TabPanel>
                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>

    )
}


const tabTypes = {
    detail: {
        id: "detail",
        title: "اطلاعات پایه"
    },
    gateway: {
        id: "gateway",
        title: "درگاه پرداخت"
    },
    transactions: {
        id: "transactions",
        title: "پرداخت ها"
    }
}